import React, { PureComponent } from 'react';

import { Button } from 'components/button';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class SubtitleTimelineZoom extends PureComponent {
  static propTypes = {
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func
  };

  render() {
    return (
      <div className="subtitle__timeline__zoom">
        <span className="subtitle__zoom__label">
          <I18n label="player_subtitles.zoom" />
        </span>

        <Button
          round
          className="subtitle__zoom__button subtitle__zoom__button--out"
          onClick={this.onZoomOut}
        ></Button>
        <Button
          round
          className="subtitle__zoom__button subtitle__zoom__button--in"
          onClick={this.onZoomIn}
        ></Button>
      </div>
    );
  }

  onZoomIn = () => {
    const { onZoomIn } = this.props;

    onZoomIn && onZoomIn();
  };

  onZoomOut = () => {
    const { onZoomOut } = this.props;

    onZoomOut && onZoomOut();
  };
}
